import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Solar Panel Installation',
        content: 'Professional solar panel installation services tailored to maximize energy efficiency and durability.',
        paragraphs: [
            'Our expert technicians provide seamless solar panel installation, ensuring optimal placement, secure mounting, and system integration for residential and commercial properties.',
            'We customize installation plans based on your energy needs, roof type, and location to deliver efficient, cost-effective solar solutions.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Certified and experienced installation professionals',
            'Use of high-quality materials and equipment',
            'Customized system design to maximize solar output',
            'Compliance with local regulations and safety standards',
            'Post-installation support and maintenance services'
        ],
        process: [
            'Site assessment and energy requirement analysis',
            'System design and equipment selection',
            'Professional installation and wiring',
            'System testing and quality assurance',
            'User training and ongoing support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How long does the installation take?',
                content: 'Typically, residential installations take 1 to 3 days depending on system size and site conditions.'
            },
            {
                id: 2,
                heading: 'Do you handle permits and inspections?',
                content: 'Yes, we manage all necessary permits, inspections, and compliance to ensure a smooth installation process.'
            },
            {
                id: 3,
                heading: 'What warranty do you offer on installation?',
                content: 'We provide a workmanship warranty that covers installation-related issues for up to 5 years.'
            },
            {
                id: 4,
                heading: 'Can I expand my system later?',
                content: 'Absolutely! Our systems are designed to be scalable to accommodate future expansion.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Wind Energy Installation',
        content: 'Expert wind turbine installation services to harness clean and sustainable wind power efficiently.',
        paragraphs: [
            'Our team specializes in installing wind energy systems for residential, commercial, and industrial applications, ensuring optimal turbine placement for maximum energy generation.',
            'We provide customized solutions including site assessment, turbine selection, and installation to meet your specific power needs while adhering to safety and regulatory standards.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Professional site evaluation and wind resource assessment',
            'Use of industry-leading wind turbines and technology',
            'Comprehensive installation with structural and electrical integration',
            'Compliance with environmental and safety regulations',
            'Post-installation monitoring and maintenance support'
        ],
        process: [
            'Initial site survey and wind analysis',
            'System design and turbine selection',
            'Foundation construction and turbine assembly',
            'Electrical wiring and grid connection',
            'Testing, commissioning, and user training'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How do I know if my location is suitable for wind energy?',
                content: 'We conduct detailed wind resource assessments to determine if your site has sufficient wind speeds for efficient energy production.'
            },
            {
                id: 2,
                heading: 'What types of wind turbines do you install?',
                content: 'We install a range of turbines suitable for small-scale residential to large commercial projects, tailored to your energy requirements.'
            },
            {
                id: 3,
                heading: 'Is wind turbine installation noisy?',
                content: 'Modern turbines operate quietly with minimal noise, designed to minimize impact on your surroundings.'
            },
            {
                id: 4,
                heading: 'Do you provide maintenance services?',
                content: 'Yes, we offer ongoing maintenance and inspection services to ensure optimal performance of your wind energy system.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Water Turbines',
        content: 'Efficient water turbine installation and maintenance for sustainable hydroelectric power generation.',
        paragraphs: [
            'Our experts provide tailored solutions for installing water turbines in rivers, dams, and other water sources to harness renewable energy effectively.',
            'We handle everything from site evaluation and turbine selection to installation and long-term system maintenance, ensuring maximum energy output and environmental compliance.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Comprehensive site analysis including water flow and head measurement',
            'High-quality turbines designed for durability and efficiency',
            'Eco-friendly installation minimizing environmental impact',
            'Integration with existing hydroelectric infrastructure',
            'Ongoing monitoring and maintenance services'
        ],
        process: [
            'Conduct hydrological and site assessments',
            'Design system layout and select appropriate turbine type',
            'Install turbine and connect to power grid',
            'Test system performance and optimize settings',
            'Provide training and maintenance support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of water turbines are available?',
                content: 'We install various types including Kaplan, Francis, and Pelton turbines based on your site’s water flow and head.'
            },
            {
                id: 2,
                heading: 'How much maintenance do water turbines require?',
                content: 'Regular inspections and routine maintenance are recommended to ensure efficiency and longevity.'
            },
            {
                id: 3,
                heading: 'Can water turbines be installed in small streams?',
                content: 'Yes, we offer micro-hydro turbine solutions suitable for smaller water sources.'
            },
            {
                id: 4,
                heading: 'Is water turbine installation environmentally safe?',
                content: 'Our installations prioritize environmental protection and comply with local regulations to minimize ecological impact.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Hybrid Energy',
        content: 'Integrated hybrid energy solutions combining solar, wind, and other renewable sources for reliable power supply.',
        paragraphs: [
            'Our hybrid energy systems are designed to optimize power generation by combining multiple renewable sources, ensuring continuous energy availability even during fluctuations.',
            'We provide customized designs, installation, and maintenance services that suit residential, commercial, and industrial needs.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Seamless integration of solar, wind, and battery storage',
            'Smart energy management systems for efficiency',
            'Reduced reliance on fossil fuels and grid power',
            'Scalable solutions for various power requirements',
            'Expert support from design to installation and maintenance'
        ],
        process: [
            'Assess energy needs and site conditions',
            'Design hybrid system combining optimal energy sources',
            'Install components and integrate control systems',
            'Test system performance and optimize output',
            'Provide ongoing monitoring and maintenance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What is hybrid energy?',
                content: 'Hybrid energy systems combine two or more renewable sources, such as solar and wind, to provide a stable power supply.'
            },
            {
                id: 2,
                heading: 'What are the benefits of hybrid energy?',
                content: 'They offer higher reliability, reduced costs, and lower environmental impact compared to single-source systems.'
            },
            {
                id: 3,
                heading: 'Can hybrid energy systems be used for homes?',
                content: 'Yes, hybrid systems are scalable and can be designed for residential as well as commercial use.'
            },
            {
                id: 4,
                heading: 'How is the system maintained?',
                content: 'Regular inspections and software updates ensure efficient operation and longevity of the hybrid energy system.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Repair Services',
        content: 'Professional repair services to restore and optimize your solar and renewable energy systems.',
        paragraphs: [
            'Our skilled technicians provide prompt and reliable repair solutions for all types of solar panels, inverters, batteries, and related equipment.',
            'We ensure minimal downtime and extend the lifespan of your energy systems with high-quality parts and expert workmanship.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Comprehensive diagnostics to identify issues quickly',
            'Replacement of faulty components with certified parts',
            'On-site repairs and maintenance for convenience',
            'Competitive pricing and transparent estimates',
            'Customer support for follow-up and advice'
        ],
        process: [
            'Schedule an inspection and diagnosis',
            'Provide a detailed repair plan and cost estimate',
            'Perform repairs with certified components',
            'Test and verify system performance post-repair',
            'Offer ongoing maintenance recommendations'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of systems do you repair?',
                content: 'We repair solar panels, inverters, batteries, wind turbines, and other renewable energy equipment.'
            },
            {
                id: 2,
                heading: 'How long do repairs typically take?',
                content: 'Repair times vary depending on the issue, but we strive to complete most repairs within 2-5 business days.'
            },
            {
                id: 3,
                heading: 'Do you offer warranty on repairs?',
                content: 'Yes, we provide warranty coverage on parts and labor for all repair services.'
            },
            {
                id: 4,
                heading: 'Can I schedule emergency repair services?',
                content: 'Emergency repair services are available for urgent issues to minimize downtime.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Maintenance Services',
        content: 'Comprehensive maintenance plans to keep your solar and renewable energy systems running efficiently.',
        paragraphs: [
            'Regular maintenance ensures optimal performance and longevity of your solar panels, wind turbines, and associated equipment.',
            'Our expert technicians conduct thorough inspections, cleaning, and preventive care to avoid costly breakdowns and maximize energy output.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Scheduled system inspections and performance checks',
            'Cleaning of solar panels and components for efficiency',
            'Preventive maintenance to detect potential issues early',
            'Firmware and software updates for smart energy devices',
            'Detailed maintenance reports and recommendations'
        ],
        process: [
            'Set up a customized maintenance schedule',
            'Perform routine inspections and cleanings',
            'Address minor repairs and component replacements',
            'Optimize system settings and firmware updates',
            'Provide maintenance summary and future advice'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How often should maintenance be done?',
                content: 'We recommend at least bi-annual maintenance checks to ensure your system performs optimally.'
            },
            {
                id: 2,
                heading: 'Do you provide emergency maintenance?',
                content: 'Yes, we offer emergency maintenance services for urgent issues affecting system performance.'
            },
            {
                id: 3,
                heading: 'Is maintenance covered under warranty?',
                content: 'Regular maintenance is usually not covered under warranty, but it helps prevent issues and prolong system life.'
            },
            {
                id: 4,
                heading: 'Can maintenance improve system efficiency?',
                content: 'Absolutely, regular maintenance helps maintain peak efficiency and prevent energy losses.'
            }
        ]
    }

];

export default services;